export const ToolStatusChip = ({
  status,
}: {
  status: "Needs approval" | "Approved" | "Rejected" | "Applied";
}) => (
  <span
    role="status"
    aria-label="Tool status"
    className={`pointer-events-none relative shrink-0 inline-flex h-[20px] items-center rounded-full border border-solid px-2 text-xs ${
      status === "Needs approval"
        ? "border-[#fed7aa] bg-[#fff7ed] text-[#b45309]"
        : status === "Rejected"
          ? "border-[#fecaca] bg-[#fef2f2] text-[#b91c1c]"
          : "border-[#bbf7d0] bg-[#f0fdf4] text-[#15803d]"
    }`}
  >
    {status}
  </span>
);
